"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcCalendarBehavior = void 0;
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_date_constants_1 = require("./bc-date-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var common_constants_2 = require("../../../common/constants/common-constants");
var bc_calendar_behavior_utilities_1 = require("./bc-calendar-behavior-utilities");
var helpers_1 = require("../../../common/helpers");
var bc_calendar_range_behavior_1 = require("./bc-calendar-range-behavior");
var BcCalendarBehavior = (function (_super) {
    __extends(BcCalendarBehavior, _super);
    function BcCalendarBehavior() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.today = new Date();
        _this.yearGroup = [_this.today.getFullYear() - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11, _this.today.getFullYear()];
        _this.displayedMonths = [];
        _this.holidayDates = [];
        _this.disabledYears = [];
        _this.bcCalendarUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        _this.bcCalendarRange = new bc_calendar_range_behavior_1.BcCalendarRangeBehavior();
        _this.bcInputDateUtilities = new bc_calendar_behavior_utilities_1.BcCalendarUtilities();
        return _this;
    }
    BcCalendarBehavior.setUpAll = function () {
        var calendarElements = Array.from(document.querySelectorAll("div[class='".concat(bc_date_constants_1.BcDateConstants.CALENDAR_CLASS, "']")));
        var elements = [];
        for (var _i = 0, calendarElements_1 = calendarElements; _i < calendarElements_1.length; _i++) {
            var element = calendarElements_1[_i];
            var calendarBehavior = new BcCalendarBehavior();
            calendarBehavior.setElement(element);
            calendarBehavior.setUp();
            elements.push(calendarBehavior);
        }
        return elements;
    };
    BcCalendarBehavior.prototype._setUp = function () {
        var mobile = this.bcCalendarUtilities.maxScreenWidth();
        this.calendarsContainer = this.mySelf;
        this.bcCalendarRange.setUpMinAndMaxDate(this, this.mySelf.getAttribute('min'), this.mySelf.getAttribute('max'));
        this.language = this.mySelf.getAttribute('language') == null ? 'es' : this.mySelf.getAttribute('language');
        if (this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY)) {
            var holidayDates = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_HOLIDAY);
            var parseHolidays = JSON.parse(holidayDates);
            if (parseHolidays) {
                if (parseHolidays.length) {
                    this.holidayDates = this.bcCalendarUtilities.holidaysMap(parseHolidays);
                }
            }
        }
        this.minDaysRange = Number(this.mySelf.getAttribute('minDaysRange'));
        this.maxDaysRange = Number(this.mySelf.getAttribute('maxDaysRange'));
        this.disabledMonths = this.parserDisabled('disabledMonths');
        this.disabledDates = this.parserDisabled('disabledDates');
        this.disabledYears = this.parserDisabled('disabledYears');
        switch (this.mySelf.getAttribute('type')) {
            case bc_date_constants_1.BcDateConstants.STATE_RANGE:
                this.caseStateRange(mobile);
                break;
            case bc_date_constants_1.BcDateConstants.STATE_SPLIT:
                this.displayedMonths = [
                    this.bcCalendarUtilities.getOneSimpleMonth(this.today.getMonth(), this.today.getFullYear()),
                ];
                this.splitCalendarSetUp();
                break;
            default:
                this.displayedMonths = [
                    this.bcCalendarUtilities.getOneSimpleMonth(this.today.getMonth(), this.today.getFullYear()),
                ];
                this.simpleCalendarSetUp();
                break;
        }
        if (this.mySelf.getAttribute('type') !== bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            this.setElementsWithFormatDate();
        }
    };
    BcCalendarBehavior.prototype.caseStateRange = function (mobile) {
        if (mobile) {
            this.displayedMonths = this.bcCalendarUtilities.getTwelveScrollableMonths(this.today.getMonth(), this.today.getFullYear());
            this.rangeMobileCalendarSetUp();
        }
        else {
            this.displayedMonths = this.bcCalendarUtilities.getTwoRangeMonths(this.today.getMonth(), this.today.getFullYear());
            this.rangeDesktopCalendarSetUp();
        }
    };
    BcCalendarBehavior.prototype.setUpDisplayedCalendars = function (calendarsContainer, topBar) {
        var _this = this;
        calendarsContainer.innerHTML = '';
        this.displayedMonths.forEach(function (displayedMonth) {
            calendarsContainer.appendChild(_this.bcCalendarRange.createAMonthElement(displayedMonth, topBar, _this, _this.language, _this.holidayDates));
        });
    };
    BcCalendarBehavior.prototype.simpleCalendarSetUp = function (daySelect) {
        var _this = this;
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonth());
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_DAYS;
        this.topBarSelector = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS));
        this.next = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS));
        this.prev = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.PREV_CLASS));
        this.monthAndDay = this.mySelf.querySelector('h6');
        this.monthAndDay.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.changeCalendarType();
            event.stopPropagation();
        });
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
        this.bcCalendarRange.addListenersForPrevAndNextBtns(this);
        if (this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != 'null' &&
            this.mySelf.getAttribute('type') != bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            this.mySelf.appendChild(this.getBottomSimple());
        }
        this.verifyTopBarSelectorChild();
        this.changeElementByDaySelected(daySelect);
    };
    BcCalendarBehavior.prototype.parserDisabled = function (attribute) {
        if (this.mySelf.getAttribute(attribute)) {
            return JSON.parse(this.mySelf.getAttribute(attribute));
        }
    };
    BcCalendarBehavior.prototype.changeElementByDaySelected = function (daySelect) {
        if (daySelect) {
            var daysCalendar = this.calendarsContainer.getElementsByClassName(bc_date_constants_1.BcDateConstants.DAYS_CLASS)[0].children;
            for (var index = common_constants_2.COMMON_CONSTANTS_NUMBERS.N0; index < daysCalendar.length; index++) {
                var element = daysCalendar[index];
                if (element.innerHTML == daySelect.innerHTML) {
                    this.changeElement(element, bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
                }
            }
        }
    };
    BcCalendarBehavior.prototype.verifyTopBarSelectorChild = function () {
        if (this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_FILTER) != 'null' &&
            this.mySelf.getAttribute('type') != bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            this.topBarSelector.appendChild(this.configFilterSimple());
        }
    };
    BcCalendarBehavior.prototype.configFilterSimple = function () {
        var _this = this;
        var filterValues = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_FILTER)
            ? this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_FILTER)
            : '[]';
        var value = JSON.parse(filterValues)[0];
        var filterContainer = document.createElement('div');
        var text = 'hoy';
        if (JSON.parse(filterValues)[1] != '') {
            text = JSON.parse(filterValues)[1];
        }
        filterContainer.innerHTML = this.bcCalendarUtilities.filterSimple(text);
        var btn = filterContainer.querySelector("button");
        btn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            if (value == 0) {
                _this.selectDateByButton(_this.today.getDate(), true);
            }
            else {
                _this.selectDateByButton(value);
            }
        });
        this.bcCalendarUtilities.focusListeners(filterContainer);
        return filterContainer;
    };
    BcCalendarBehavior.prototype.prependMobileTitleText = function () {
        var _this = this;
        var title = document.createElement('p');
        title.classList.add(bc_date_constants_1.BcDateConstants.MOBILE_TITLE_CLASS);
        title.textContent = bc_date_constants_1.BcDateConstants.MOBILE_CALENDAR_TITLE;
        this.mySelf.prepend(title);
        this.mySelf.insertAdjacentHTML('beforeend', "<em class=\"".concat(common_constants_1.BcCommonConstants.ICONS_CLASS, "\n      ").concat(common_constants_1.BcCommonConstants.ICON_SM_CLASS, "\n      ").concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS, " ").concat(bc_date_constants_1.BcDateConstants.BTN_X_CLASS, "\">error</em>"));
        this.btnCancel = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS));
        this.btnCancel.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.eventRangeCanceled();
        });
    };
    BcCalendarBehavior.prototype.setElementsWithCalendarState = function (displayedMonth) {
        switch (this.calendarState) {
            case bc_date_constants_1.BcDateConstants.STATE_SPLIT:
                this.setUpDisplayedMonthElement(displayedMonth);
                break;
            case bc_date_constants_1.BcDateConstants.STATE_MONTHS:
                this.setElementsForMonthSelector();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_YEARS:
                this.setElementsForYearSelector();
                break;
            default:
                this.setUpDisplayedMonthElement(displayedMonth);
                break;
        }
    };
    BcCalendarBehavior.prototype.setElementsWithFormatDate = function (daySelect) {
        var _a;
        switch ((_a = this.mySelf.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.querySelectorAll('input')[0].getAttribute(bc_date_constants_1.BcDateConstants.FORMAT_DATE)) {
            case bc_date_constants_1.DateFormate.fullDate:
                this.simpleCalendarSetUp(daySelect);
                break;
            case bc_date_constants_1.DateFormate.mediumDate:
                this.setElementsForMonthSelector(daySelect);
                break;
            case bc_date_constants_1.DateFormate.shortDate:
                this.setElementsForYearSelector();
                break;
            default:
                this.simpleCalendarSetUp();
                break;
        }
    };
    BcCalendarBehavior.prototype.setUpDisplayedMonthElement = function (displayedMonth) {
        switch (this.calendarState) {
            case bc_date_constants_1.BcDateConstants.STATE_RANGE:
                this.rangeDesktopCalendarSetUp();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_SPLIT:
                this.splitCalendarSetUp();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_DAYS:
                this.simpleCalendarSetUp();
                break;
            default:
                this.simpleCalendarSetUp();
        }
    };
    BcCalendarBehavior.prototype.setUpDisplayedCalendarse = function () {
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonthSplitSelector());
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_SPLIT;
        this.topBarSelector = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS));
        this.prevMonthBtn = this.topBarSelector.childNodes[0];
        this.nextMonthBtn = this.topBarSelector.childNodes[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N3];
        (0, helpers_1.addFocusable)(this.prevMonthBtn, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.nextMonthBtn, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.prevMonthBtn);
        this.bcCalendarUtilities.focusListeners(this.nextMonthBtn);
    };
    BcCalendarBehavior.prototype.splitCalendarSetUp = function () {
        this.setUpDisplayedCalendarse();
        this.prevYearBtn = this.topBarSelector.childNodes[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N5];
        this.nextYearBtn = this.topBarSelector.childNodes[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N7];
        (0, helpers_1.addFocusable)(this.prevYearBtn, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.nextYearBtn, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.prevYearBtn);
        this.bcCalendarUtilities.focusListeners(this.nextYearBtn);
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
        this.monthTopBar = this.topBarSelector.querySelectorAll('h6')[0];
        this.yearTopBar = this.topBarSelector.querySelectorAll('h6')[1];
        (0, helpers_1.addFocusable)(this.monthTopBar, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.yearTopBar, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.monthTopBar);
        this.bcCalendarUtilities.focusListeners(this.yearTopBar);
        this.bcCalendarRange.addListenersForSplitSelectorCalendar(this);
        if (this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != null &&
            this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != 'null' &&
            this.mySelf.getAttribute('type') != bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            this.mySelf.appendChild(this.getBottomSimple());
        }
    };
    BcCalendarBehavior.prototype.selectYear = function (i, displayedMonth) {
        displayedMonth.year = i;
        if (this.mySelf.getAttribute('type') === bc_date_constants_1.BcDateConstants.STATE_SPLIT) {
            this.splitCalendarSetUp();
        }
        else {
            this.setElementsForMonthSelector();
        }
    };
    BcCalendarBehavior.prototype.addListenerToSelectYear = function (element, year) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            var _a;
            _this.selectYear(year, _this.displayedMonths[0]);
            var format = (_a = _this.mySelf.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.querySelectorAll('input')[0].getAttribute(bc_date_constants_1.BcDateConstants.FORMAT_DATE);
            if (format === bc_date_constants_1.DateFormate.shortDate) {
                _this.selectCalendarOption(element, format);
            }
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(element, function () {
            _this.selectYear(year, _this.displayedMonths[0]);
        });
    };
    BcCalendarBehavior.prototype.setElementsForMonthSelector = function (monthSelected) {
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_MONTHS;
        this.mySelf.innerHTML = this.bcCalendarUtilities.getCalendarSelectMonthOrYear();
        this.topBarSelector = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS));
        this.addPrevAndNextBtnsToChangeYear();
        this.changeYearAndAddListener();
        this.monthsOrYearsContainer = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.MONTHS_OR_YEARS_CLASS));
        this.bcCalendarRange.addMonthsPicker(this, this.language);
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
        this.actualMonth();
        if (monthSelected) {
            var monthsCalendar = this.monthsOrYearsContainer.children;
            for (var index = 0; index < monthsCalendar.length; index++) {
                if (monthsCalendar[index].innerHTML == monthSelected.innerHTML) {
                    this.changeElement(this.monthsOrYearsContainer.children[index], bc_date_constants_1.BcDateConstants.SELECTED_DATE_MONTH_CLASS);
                }
            }
        }
    };
    BcCalendarBehavior.prototype.actualMonth = function () {
        var year = this.topBarSelector.getElementsByTagName(common_constants_1.BcCommonConstants.H6_TAG)[0].innerHTML;
        for (var _i = 0, _a = Array.from(this.monthsOrYearsContainer.children); _i < _a.length; _i++) {
            var monthChild = _a[_i];
            if (String(this.today.getMonth()) == monthChild.getAttribute(bc_date_constants_1.BcDateConstants.MONTH_NUMBER)
                && year == String(this.today.getFullYear())) {
                monthChild.classList.add(bc_date_constants_1.BcDateConstants.TODAY_CLASS);
            }
        }
    };
    BcCalendarBehavior.prototype.changeYearAndAddListener = function () {
        var _this = this;
        var yearName = this.topBarSelector.querySelector('h6');
        (0, helpers_1.addFocusable)(yearName, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(yearName);
        yearName.textContent = "".concat(this.displayedMonths[0].year);
        yearName.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.changeCalendarType();
            event.stopPropagation();
        }, { once: true });
        this.bcCalendarRange.addEnterKeyListener(yearName, function (event) {
            _this.changeCalendarType();
            event.stopPropagation();
        });
    };
    BcCalendarBehavior.prototype.setElementsForYearSelector = function () {
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_YEARS;
        this.yearGroup = [
            this.displayedMonths[0].year - bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N11,
            this.displayedMonths[0].year,
        ];
        this.mySelf.innerHTML = this.bcCalendarUtilities.getCalendarSelectMonthOrYear();
        this.topBarSelector = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.TOP_BAR_SELECTOR_CLASS));
        this.addPrevAndNextBtnsToChangeYearGroup();
        this.changeYearGroupAndAddListener();
        this.monthsOrYearsContainer = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.MONTHS_OR_YEARS_CLASS));
        this.addYearsPicker();
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.prependMobileTitleText();
        }
    };
    BcCalendarBehavior.prototype.changeYearGroupAndAddListener = function () {
        var _this = this;
        this.yearGroupName = this.topBarSelector.querySelector('h6');
        (0, helpers_1.addFocusable)(this.yearGroupName, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.yearGroupName);
        this.yearGroupName.textContent = "".concat(this.yearGroup[0], " - ").concat(this.yearGroup[1]);
        this.yearGroupName.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.changeCalendarType();
            event.stopPropagation();
        }, { once: true });
        this.bcCalendarRange.addEnterKeyListener(this.yearGroupName, function (event) {
            _this.changeCalendarType();
            event.stopPropagation();
        });
    };
    BcCalendarBehavior.prototype.createBtnsfromArray = function (numbers, texts, operations) {
        if (!operations) {
            operations = [];
        }
        if (numbers != null) {
            for (var i = 0; i < numbers.length; i++) {
                this.upperBtnsContainer.appendChild(this.bcCalendarUtilities.createARangeButton(numbers[i], texts ? texts[i] : null, this.language, operations[i]));
            }
        }
    };
    BcCalendarBehavior.prototype.rangeDesktopCalendarFirstSet = function () {
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_RANGE;
        this.mySelf.innerHTML = '';
        this.mySelf.innerHTML = this.bcCalendarUtilities.getRangeCalendarButtons();
        this.upperBtnsContainer = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.UPPPER_BTNS_CLASS));
        var operations = this.mySelf.getAttribute('operations') ? this.mySelf.getAttribute('operations')
            : '[]';
        var rangesBtns = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES)
            ? this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES)
            : '[]';
        var rangeBtnsArray = [];
        try {
            rangeBtnsArray = JSON.parse(rangesBtns);
        }
        catch (err) {
            rangeBtnsArray = [];
        }
        var rangesTextBtns = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT)
            ? this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT)
            : '[]';
        var rangeTextBtnsArray = [];
        try {
            rangeTextBtnsArray = JSON.parse(rangesTextBtns);
        }
        catch (err) {
            rangeTextBtnsArray = [];
        }
        var operationsArray = [];
        try {
            operationsArray = JSON.parse(operations);
        }
        catch (err) {
            operationsArray = [];
        }
        this.createBtnsfromArray(rangeBtnsArray, rangeTextBtnsArray, operationsArray);
    };
    BcCalendarBehavior.prototype.rangeDesktopCalendarSetUp = function () {
        this.rangeDesktopCalendarFirstSet();
        this.calendarsContainer = document.createElement('div');
        this.calendarsContainer.classList.add(bc_date_constants_1.BcDateConstants.TWO_CALENDARS_CLASS);
        this.mySelf.appendChild(this.calendarsContainer);
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarSingleMonth());
        this.mySelf.appendChild(this.getDesktopConfirmBottomRange());
        this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS))[0].textContent = ' ';
        this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.PREV_CLASS))[1].textContent = ' ';
        this.next = this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.NEXT_CLASS))[1];
        this.prev = this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.PREV_CLASS))[0];
        if (this.selectedDates) {
            this.selectRange();
        }
        this.addButtonListenersForConfirmAndCancel();
        this.bcCalendarRange.addListenersForPrevAndNextBtns(this);
        this.addButtonListenersForUpperBtns();
    };
    BcCalendarBehavior.prototype.rangeMobileCalendarSetUp = function () {
        this.calendarState = bc_date_constants_1.BcDateConstants.STATE_RANGE;
        this.mySelf.innerHTML = '';
        this.mySelf.classList.add(bc_date_constants_1.BcDateConstants.MOBILE_CALENDAR_CLASS);
        this.calendarsContainer = document.createElement('div');
        this.calendarsContainer.classList.add(bc_date_constants_1.BcDateConstants.SCROLLABLE_CALENDARS_CLASS);
        var rangesBtns = this.addUpperBtnsMobile();
        this.mySelf.appendChild(this.calendarsContainer);
        this.setUpDisplayedCalendars(this.calendarsContainer, this.bcCalendarUtilities.topBarMobileScrollable());
        this.mySelf.appendChild(this.getFixedItemsScrollableCalendars());
        if (this.selectedDates) {
            this.selectRange();
        }
        if (rangesBtns != 'null' && rangesBtns != null) {
            this.calendarsContainer.classList.add(bc_date_constants_1.BcDateConstants.FIX_UPPER_BUTTONS);
        }
        this.addButtonListenersForConfirmAndCancel();
    };
    BcCalendarBehavior.prototype.addUpperBtnsMobile = function () {
        var rangesBtns = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES)
            ? this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES)
            : '[]';
        var operations = this.mySelf.getAttribute('operations') ? this.mySelf.getAttribute('operations')
            : '[]';
        var rangeBtnsArray = [];
        try {
            rangeBtnsArray = JSON.parse(rangesBtns);
        }
        catch (err) {
            rangeBtnsArray = [];
        }
        var rangesTextBtns = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT)
            ? this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.RANGES_TEXT)
            : '[]';
        var rangeTextBtnsArray = [];
        try {
            rangeTextBtnsArray = JSON.parse(rangesTextBtns);
        }
        catch (err) {
            rangeTextBtnsArray = [];
        }
        var operationsArray = [];
        try {
            operationsArray = JSON.parse(operations);
        }
        catch (err) {
            operationsArray = [];
        }
        if (rangesBtns != 'null' && rangesBtns != null) {
            this.mySelf.innerHTML = this.bcCalendarUtilities.getRangeCalendarButtons();
            this.upperBtnsContainer = this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.UPPPER_BTNS_CLASS));
            this.createBtnsfromArray(rangeBtnsArray, rangeTextBtnsArray, operationsArray);
            this.addButtonListenersForUpperBtns();
        }
        return rangesBtns;
    };
    BcCalendarBehavior.prototype.getDesktopConfirmBottomRange = function () {
        var btnsContainer = document.createElement('div');
        btnsContainer.classList.add(bc_date_constants_1.BcDateConstants.BUTTONS_RANGE_CONTAINER_CLASS);
        btnsContainer.innerHTML = this.bcCalendarUtilities.confirmBtnsString(this.language);
        this.btnConfirm = btnsContainer.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS));
        if (!this.selectedDates) {
            this.btnConfirm.setAttribute(common_constants_1.BcCommonConstants.DISABLED, 'true');
        }
        this.btnCancel = btnsContainer.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS));
        this.btnRestore = btnsContainer.querySelector(".".concat(bc_date_constants_1.BcDateConstants.RESTORE_CLASS));
        return btnsContainer;
    };
    BcCalendarBehavior.prototype.getBottomSimple = function () {
        var _this = this;
        var btnsContainer = document.createElement('div');
        btnsContainer.classList.add(bc_date_constants_1.BcDateConstants.BUTTONS_SIMPLE_CONTAINER_CLASS);
        var text = 'Aceptar';
        if (this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON) != '') {
            text = this.mySelf.getAttribute(bc_date_constants_1.BcDateConstants.CALENDAR_BUTTON);
        }
        btnsContainer.innerHTML = this.bcCalendarUtilities.confirmBtnString(text);
        this.btnConfirm = btnsContainer.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS));
        (0, helpers_1.addFocusable)(this.btnConfirm, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.btnConfirm);
        this.btnConfirm.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.selectDateByButton();
        });
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.btnConfirm.classList.add(bc_date_constants_1.BcDateConstants.MOBILE_CONFIRM_CLASS);
        }
        return btnsContainer;
    };
    BcCalendarBehavior.prototype.getFixedItemsScrollableCalendars = function () {
        var fixedContent = document.createElement('div');
        fixedContent.classList.add(bc_date_constants_1.BcDateConstants.FIXED_CONTENT_CLASS);
        fixedContent.innerHTML = this.bcCalendarUtilities.getContentFixedContainer();
        this.btnConfirm = fixedContent.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CONFIRM_CLASS));
        this.btnCancel = fixedContent.querySelector(".".concat(bc_date_constants_1.BcDateConstants.CANCEL_CLASS));
        return fixedContent;
    };
    BcCalendarBehavior.prototype.addButtonListenersForConfirmAndCancel = function () {
        var _this = this;
        this.btnConfirm.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.eventRangeSelected();
        });
        this.btnCancel.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.eventRangeCanceled();
        });
        if (!this.bcCalendarUtilities.maxScreenWidth()) {
            this.btnRestore.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
                var event = new CustomEvent(bc_date_constants_1.BcDateConstants.CALENDAR_EVENT_CHANGE_DATE, { detail: { value: '' } });
                _this.mySelf.dispatchEvent(event);
                _this.eventRangeRestore();
            });
        }
    };
    BcCalendarBehavior.prototype.addButtonListenersForUpperBtns = function () {
        var _this = this;
        this.upperBtnsContainer.childNodes.forEach(function (btn) {
            var numberAttr = parseInt(btn.getAttribute('value'));
            var operationAttr = btn.getAttribute('operation');
            btn.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (e) {
                _this.deactivateUpperBtns();
                btn.classList.add(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER_ACTIVE);
                _this.bcCalendarRange.automaticRange(numberAttr, _this, operationAttr);
            });
        });
    };
    BcCalendarBehavior.prototype.addPrevAndNextBtnsToChangeYear = function () {
        var _this = this;
        this.next = this.mySelf.querySelector('.' + bc_date_constants_1.BcDateConstants.NEXT_CLASS);
        this.prev = this.mySelf.querySelector('.' + bc_date_constants_1.BcDateConstants.PREV_CLASS);
        (0, helpers_1.addFocusable)(this.next, { tabindex: '0' });
        (0, helpers_1.addFocusable)(this.prev, { tabindex: '0' });
        this.bcCalendarUtilities.focusListeners(this.next);
        this.bcCalendarUtilities.focusListeners(this.prev);
        this.next.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.displaceYears(_this.displayedMonths[0], 1, _this);
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(this.next, function () {
            _this.bcCalendarUtilities.displaceYears(_this.displayedMonths[0], 1, _this);
            _this.next.focus();
        });
        this.prev.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            _this.bcCalendarUtilities.displaceYears(_this.displayedMonths[0], -1, _this);
            event.stopPropagation();
        });
        this.bcCalendarRange.addEnterKeyListener(this.prev, function () {
            _this.bcCalendarUtilities.displaceYears(_this.displayedMonths[0], -1, _this);
            _this.prev.focus();
        });
    };
    BcCalendarBehavior.prototype.addPrevAndNextBtnsToChangeYearGroup = function () {
        this.next = this.mySelf.querySelector('.' + bc_date_constants_1.BcDateConstants.NEXT_CLASS);
        this.prev = this.mySelf.querySelector('.' + bc_date_constants_1.BcDateConstants.PREV_CLASS);
        this.bcCalendarRange.addListenerToBtnYearGroup(this);
    };
    BcCalendarBehavior.prototype.changeCalendarType = function () {
        switch (this.calendarState) {
            case bc_date_constants_1.BcDateConstants.STATE_DAYS:
                this.setElementsForMonthSelector();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_MONTHS:
                this.setElementsForYearSelector();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_YEARS:
                this.setElementsForMonthSelector();
                break;
            case bc_date_constants_1.BcDateConstants.STATE_SPLIT:
                this.splitCalendarSetUp();
                break;
            default:
                this.simpleCalendarSetUp();
        }
    };
    BcCalendarBehavior.prototype.addYearsPicker = function () {
        this.monthsOrYearsContainer.innerHTML = '';
        for (var i = 0; i <= this.yearGroup[1] - this.yearGroup[0]; i++) {
            var year = document.createElement('p');
            var numericYear = this.yearGroup[0] + i;
            year.textContent = "".concat(numericYear);
            if (this.today.getFullYear() == numericYear) {
                year.classList.add(bc_date_constants_1.BcDateConstants.THIS_MONTH_OR_YEAR_CLASS);
            }
            (0, helpers_1.addFocusable)(year, { tabindex: '0' });
            this.bcCalendarUtilities.focusListeners(year);
            this.monthsOrYearsContainer.appendChild(year);
            year.setAttribute(bc_date_constants_1.BcDateConstants.ID, "".concat(bc_date_constants_1.BcDateConstants.ID_YEAR).concat(year.textContent));
            this.verifyDisabledYears(year);
            this.bcCalendarUtilities.keyReader(year, this);
            this.addListenerToSelectYear(year, numericYear);
        }
    };
    BcCalendarBehavior.prototype.verifyDisabledYears = function (year) {
        if (this.disabledYears) {
            var result = this.disabledYears.filter(function (item) { return item == year.textContent; });
            if (result.length) {
                year.classList.add(bc_date_constants_1.BcDateConstants.DISABLED_MONTH);
            }
            if (this.maxDate && this.minDate) {
                if (Number(year.textContent) > this.maxDate.getFullYear() + 1 || Number(year.textContent) < this.minDate.getFullYear() + 1) {
                    year.classList.add(bc_date_constants_1.BcDateConstants.DISABLED_MONTH);
                }
            }
        }
    };
    BcCalendarBehavior.prototype.selectDateByButton = function (day, now) {
        var _a;
        if (this.calendarState == bc_date_constants_1.BcDateConstants.STATE_RANGE && !this.bcCalendarUtilities.maxScreenWidth()) {
            this.deactivateUpperBtns();
        }
        var element = this.getElement(day);
        if (!this.firstDateIsSelected && !(element === null || element === void 0 ? void 0 : element.classList.contains(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS))) {
            if (this.calendarState !== bc_date_constants_1.BcDateConstants.STATE_RANGE) {
                this.deleteAllSelected();
            }
            var calendarElement = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
            this.date = new Date();
            this.date.setHours(bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12);
            if (!now) {
                this.date.setMonth(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement), this.language), parseInt(element.textContent));
                this.date.setFullYear(parseInt(this.bcCalendarUtilities.getClickedDateYear(calendarElement)));
            }
            this.dateFormatIsosString();
            this.selectDateOneDates(this.dateFormatIsosString());
        }
        else {
            this.selectDateTwo(element);
        }
        this.addBorderSelectedDates();
    };
    BcCalendarBehavior.prototype.dateFormatIsosString = function () {
        var NUMBER_TEN = 10;
        return this.date.toISOString().substring(0, NUMBER_TEN);
    };
    BcCalendarBehavior.prototype.dateFormatYear = function () {
        var options = {
            timeZone: 'America/Bogota',
            year: 'numeric',
        };
        return this.date.toLocaleDateString('es-CO', options);
    };
    BcCalendarBehavior.prototype.dateFormatMonthAndYear = function () {
        var options = {
            timeZone: 'America/Bogota',
            year: 'numeric',
            month: 'long',
        };
        return this.date.toLocaleDateString(this.bcCalendarUtilities.getLocalesByLanguage(this.language), options);
    };
    BcCalendarBehavior.prototype.getElement = function (day) {
        var element;
        if (day != null) {
            element = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(day));
        }
        else {
            element = document.getElementById("".concat(bc_date_constants_1.BcDateConstants.ID_DAY).concat(this.focus));
        }
        return element;
    };
    BcCalendarBehavior.prototype.selectCalendarOption = function (element, type) {
        if (this.calendarState == bc_date_constants_1.BcDateConstants.STATE_RANGE && !this.bcCalendarUtilities.maxScreenWidth()) {
            this.deactivateUpperBtns();
        }
        this.changeStylesBorderInputs();
        if (!this.firstDateIsSelected && !element.classList.contains(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS)) {
            if (this.calendarState !== bc_date_constants_1.BcDateConstants.STATE_RANGE) {
                this.deleteAllSelected();
            }
            element.classList.add(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
            this.date = new Date();
            this.date.setHours(bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12);
            if (type === bc_date_constants_1.DateFormate.fullDate) {
                this.configFullView(element);
            }
            if (type === bc_date_constants_1.DateFormate.mediumDate) {
                this.configMediumView(element);
            }
            if (type === bc_date_constants_1.DateFormate.shortDate) {
                this.configShortView(element);
            }
        }
        else {
            this.selectDateTwo(element);
        }
        this.addBorderSelectedDates();
    };
    BcCalendarBehavior.prototype.changeElement = function (element, classUpdate) {
        element.classList.add(classUpdate);
    };
    BcCalendarBehavior.prototype.configFullView = function (element) {
        var _a;
        var calendarElement = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
        var dateFormated = this.bcInputDateUtilities.formatDate(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement), this.language) + 1, element.textContent, this.bcCalendarUtilities.getClickedDateYear(calendarElement), 'MM/dd/yyyy');
        this.date = new Date(dateFormated);
        this.dispatchEventChangeDate(0, this.date);
        this.selectDateOneDates(this.dateFormatIsosString());
        this.verifyMinMaxDaysSelect(calendarElement, element);
        if (this.firstDateIsSelected) {
            this.dateSelectedFirst =
                new Date(Number(element.getAttribute('year')), Number(element.getAttribute('month')), Number(element.textContent));
        }
    };
    BcCalendarBehavior.prototype.verifyMinMaxDaysSelect = function (calendarElement, element) {
        if (this.minDaysRange && this.maxDaysRange) {
            var days = Array.from(calendarElement.parentElement.children);
            for (var _i = 0, days_1 = days; _i < days_1.length; _i++) {
                var elementDay = days_1[_i];
                var pElements = Array.from(elementDay.children[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2].children);
                for (var _a = 0, pElements_1 = pElements; _a < pElements_1.length; _a++) {
                    var pElement = pElements_1[_a];
                    this.bcCalendarRange.rangeMaxMinSelectTest(Number(element.getAttribute('month')), Number(element.textContent), Number(element.getAttribute('year')), pElement, this.minDaysRange - 1, this.maxDaysRange + bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2, true);
                    var monthinfo = {
                        year: Number(pElement.getAttribute('year')),
                        month: Number(pElement.getAttribute('month'))
                    };
                    this.bcCalendarRange.disabledDates(monthinfo, Number(pElement.textContent), pElement, this);
                }
            }
        }
    };
    BcCalendarBehavior.prototype.changeStylesBorderInputs = function () {
        if (this.mySelf.parentElement) {
            if (this.calendarState == bc_date_constants_1.BcDateConstants.STATE_RANGE) {
                var inputDate = this.mySelf.parentElement.parentElement.getElementsByClassName('bc-input')[0];
                var inputDate2 = this.mySelf.parentElement.parentElement.getElementsByClassName('bc-input')[1];
                if (inputDate && inputDate2) {
                    if (this.firstDateIsSelected) {
                        inputDate.style.borderBottom = bc_date_constants_1.BcDateConstants.STYLE_BORDER_SOLID;
                        inputDate2.style.borderBottom = '';
                    }
                    else {
                        inputDate2.style.borderBottom = bc_date_constants_1.BcDateConstants.STYLE_BORDER_SOLID;
                        inputDate.style.borderBottom = '';
                    }
                }
            }
        }
    };
    BcCalendarBehavior.prototype.cleanStylesInputs = function (inputDate) {
        inputDate.style.borderBottom = '';
    };
    BcCalendarBehavior.prototype.configMediumView = function (element) {
        var _a;
        var yearElement = (_a = this.mySelf.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.getElementsByClassName('bc-calendar-top-bar')[0].querySelectorAll(common_constants_1.BcCommonConstants.H6_TAG)[0].textContent;
        this.date.setMonth(this.bcCalendarUtilities.getMonthShorIndex(element.textContent, this.language));
        if (yearElement) {
            if (yearElement.length > bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N4) {
                this.date.setFullYear(parseInt(yearElement.split(' ')[1]));
            }
            else {
                this.date.setFullYear(Number(yearElement));
            }
        }
        this.selectDateOneDates(this.dateFormatMonthAndYear());
    };
    BcCalendarBehavior.prototype.configShortView = function (element) {
        this.date.setFullYear(parseInt(element.textContent));
        this.selectDateOneDates(this.dateFormatYear());
    };
    BcCalendarBehavior.prototype.selectDateOneDates = function (date) {
        var event = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_SELECT, {
            detail: date,
        });
        this.mySelf.dispatchEvent(event);
        if (this.selectedDates && this.selectedDates.length === bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2) {
            this.addDatesToArraySelectRangeAndSort();
        }
        if (this.calendarState === bc_date_constants_1.BcDateConstants.STATE_RANGE) {
            this.firstDateIsSelected = true;
        }
    };
    BcCalendarBehavior.prototype.selectDateTwo = function (element) {
        var _a;
        if (!element.classList.contains(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS)) {
            var calendarElement = (_a = element.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement;
            this.dateTwo = new Date();
            this.dateTwo.setHours(bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N12);
            this.dateTwo.setMonth(this.bcCalendarUtilities.getMonthIndex(this.bcCalendarUtilities.getClickedDateMonth(calendarElement), this.language), parseInt(element.textContent));
            this.dateTwo.setFullYear(Number(element.getAttribute('year')));
            this.dispatchEventChangeDate(1, this.dateTwo);
            this.addDatesToArraySelectRangeAndSort();
            this.btnConfirm.removeAttribute('disabled');
            this.firstDateIsSelected = false;
        }
    };
    BcCalendarBehavior.prototype.dispatchEventChangeDate = function (numberInput, input) {
        var event = new CustomEvent(bc_date_constants_1.BcDateConstants.CALENDAR_EVENT_CHANGE_DATE, {
            detail: {
                numberInput: numberInput,
                value: input.toISOString().substring(0, bc_date_constants_1.SIZE_DATE_STR)
            }
        });
        this.mySelf.dispatchEvent(event);
    };
    BcCalendarBehavior.prototype.addDatesToArraySelectRangeAndSort = function () {
        var _this = this;
        this.selectedDates = [this.date, this.dateTwo];
        this.selectedDates.sort(function (a, b) { return _this.bcCalendarUtilities.compareDates(a, b); });
        this.selectRange();
        if (this.bcCalendarUtilities.maxScreenWidth()) {
            this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.FROM_CLASS)).textContent = this.dateToStringFormat(this.selectedDates[0]);
            this.mySelf.querySelector(".".concat(bc_date_constants_1.BcDateConstants.TO_CLASS)).textContent = this.dateToStringFormat(this.selectedDates[1]);
        }
    };
    BcCalendarBehavior.prototype.dateToStringFormat = function (selectedDate) {
        var parts = selectedDate.toISOString().substring(0, bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N10).split('-');
        return "".concat(parts[bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2], " ").concat(this.bcCalendarUtilities.getListMonthShortByLanguage(this.language)[parseInt(parts[1]) - 1], " ").concat(parts[0]);
    };
    BcCalendarBehavior.prototype.selectRange = function () {
        var _this = this;
        this.deleteAllRange();
        this.deleteAllSelected();
        var monthsInCalendar = this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.DISPLAYED_CALENDARS_CLASS));
        var _loop_1 = function (i) {
            var displayedMonth = this_1.displayedMonths[i];
            var monthElement = monthsInCalendar[i];
            var days = monthElement.querySelectorAll('.' + bc_date_constants_1.BcDateConstants.DAY);
            days.forEach(function (day) {
                var tempDate = new Date(displayedMonth.year, displayedMonth.month, parseInt(day.textContent));
                _this.setAllDatesToZeroHours(tempDate);
                _this.addClassesSelectRange(tempDate, day);
            });
        };
        var this_1 = this;
        for (var i = 0; i < monthsInCalendar.length; i++) {
            _loop_1(i);
        }
    };
    BcCalendarBehavior.prototype.addClassesSelectRange = function (tempDate, day) {
        if (this.today.getTime() == tempDate.getTime()) {
            day.classList.add(bc_date_constants_1.BcDateConstants.TODAY_CLASS);
        }
        if (this.selectedDates[0].getTime() == tempDate.getTime()) {
            day.classList.add(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS, bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS);
        }
        if (this.selectedDates[1].getTime() == tempDate.getTime()) {
            day.classList.add(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS, bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS);
        }
        if (this.selectedDates[0].getTime() <= tempDate.getTime() &&
            this.selectedDates[1].getTime() >= tempDate.getTime()) {
            day.classList.add(bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS);
        }
    };
    BcCalendarBehavior.prototype.setAllDatesToZeroHours = function (tempDate) {
        tempDate.setHours(0, 0, 0, 0);
        this.selectedDates[0].setHours(0, 0, 0, 0);
        this.selectedDates[1].setHours(0, 0, 0, 0);
        this.today.setHours(0, 0, 0, 0);
    };
    BcCalendarBehavior.prototype.deleteAllRange = function () {
        this.mySelf.querySelectorAll('.' + bc_date_constants_1.BcDateConstants.DAY).forEach(function (day) {
            day.classList.remove(bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS);
        });
    };
    BcCalendarBehavior.prototype.deleteAllSelected = function () {
        this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS)).forEach(function (day) {
            day.classList.remove(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
            day.removeAttribute('date-selection');
        });
    };
    BcCalendarBehavior.prototype.selectMonth = function (i, displayedMonth) {
        displayedMonth.month = i;
        if (this.mySelf.getAttribute('type') === bc_date_constants_1.BcDateConstants.STATE_SPLIT) {
            this.splitCalendarSetUp();
        }
        else {
            this.simpleCalendarSetUp();
        }
    };
    BcCalendarBehavior.prototype.eventRangeRestore = function () {
        this.date = undefined;
        this.dateTwo = undefined;
        this.displayedMonths = undefined;
        this.firstDateIsSelected = undefined;
        this.selectedDates = undefined;
        this.dateSelectedFirst = undefined;
        this.deleteAllRange();
        this.deleteAllSelected();
        this._setUp();
    };
    BcCalendarBehavior.prototype.eventRangeSelected = function () {
        if (this.selectedDates && this.selectedDates.length === bc_date_constants_1.BcDateConstants.NUMBERS.CALENDAR_N2) {
            var event_1 = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_RANGE, {
                detail: this.selectedDates,
            });
            this.mySelf.dispatchEvent(event_1);
        }
        else {
            this.eventRangeCanceled();
        }
    };
    BcCalendarBehavior.prototype.eventRangeCanceled = function () {
        var event = new CustomEvent(common_constants_1.BcCommonConstants.EVENT_CANCEL);
        this.mySelf.dispatchEvent(event);
    };
    BcCalendarBehavior.prototype.emitEvent = function () {
        this.value = this.selectedDates;
        if (this.output) {
            this.output(this.value);
        }
    };
    BcCalendarBehavior.prototype.deactivateUpperBtns = function () {
        this.upperBtnsContainer.childNodes.forEach(function (btn) {
            if (btn.classList.contains(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER_ACTIVE)) {
                btn.classList.remove(bc_date_constants_1.BcDateConstants.BC_TAG_FILTER_ACTIVE);
            }
        });
    };
    BcCalendarBehavior.prototype.addBorderSelectedDates = function () {
        var DATE_SELECTION = 'date-selection';
        var secondDateSelector = ".".concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS, "~ .").concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
        var firstDateSelector = ".".concat(bc_date_constants_1.BcDateConstants.DISPLAYED_CALENDARS_CLASS, ":first-of-type .").concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
        var allDateSelector = ".".concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS);
        var notDateSelectionSelector = ".".concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS, ":not([date-selection])");
        var rangeIsPresentSelector = ".".concat(bc_date_constants_1.BcDateConstants.SELECTED_DATE_CLASS, ".").concat(bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS);
        var secondDateSelected = this.mySelf.querySelector(secondDateSelector);
        if (secondDateSelected) {
            secondDateSelected.setAttribute(DATE_SELECTION, '2');
            this.mySelf.querySelector(notDateSelectionSelector).setAttribute(DATE_SELECTION, '1');
        }
        else if (this.mySelf.querySelectorAll(allDateSelector).length > 1) {
            this.mySelf.querySelector(firstDateSelector).setAttribute(DATE_SELECTION, '1');
            this.mySelf.querySelector(notDateSelectionSelector).setAttribute(DATE_SELECTION, '2');
        }
        else if (this.mySelf.querySelector(rangeIsPresentSelector)) {
            if (this.mySelf.querySelector("".concat(rangeIsPresentSelector, "~").concat(bc_date_constants_1.BcDateConstants.INSIDE_RANGE_CLASS))) {
                this.mySelf.querySelector(rangeIsPresentSelector).setAttribute(DATE_SELECTION, '1');
            }
            else {
                this.mySelf.querySelector(rangeIsPresentSelector).setAttribute(DATE_SELECTION, '2');
            }
        }
    };
    return BcCalendarBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcCalendarBehavior = BcCalendarBehavior;
